import script from "./EmpresasCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpresasCadastro.vue?vue&type=script&setup=true&lang=js"

import "./EmpresasCadastro.vue?vue&type=style&index=0&id=e2f2fb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f2fb9e"]])

export default __exports__